module.exports = __webpack_public_path__ + "static/media/854NorthAvenueNW_2018-07-09_204.b8618d95.jpg";